import { createActionBundle } from 'utilities/request';

export const {
  request: requestQuestionnaireResponse,
  success: requestQuestionnaireResponseSuccess,
  failure: requestQuestionnaireResponseFailure,
} = createActionBundle('QUESTIONNAIRE_RESPONSE');
